<template>
  <question-card
    class="credit-score-step"
    :disabled="canNotSubmit"
    @submit="submit"
    :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]"
  >
    <template #title> {{UIComponentData.Header.Translations[questionnaireLead.Language]}} </template>
    <div class="credit-score-step__scoremeter scoremeter">
      <svg
        class="scoremeter__scale-value"
        :width="scoremeterSize.width"
        :height="scoremeterSize.height"
        :viewBox="`0 0 ${scoremeterSize.width} ${scoremeterSize.height}`"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          v-for="(item, key) in scoreScale"
          :key="key"
          @click="selectScore(key)"
          class="scoremeter__scale-value"
          :d="getDValue(item)"
          :fill="item.color"
          :stroke="selectedScore === item ? '#0b53ff' : item.color"
          stroke-width="3"
        />
      </svg>
      <img
        :style="needleTransform"
        src="@/assets/images/score_needle.svg"
        class="scoremeter__needle"
      />
      <div>
        <span
          v-for="(item, key) in scoreScale"
          :key="key"
          @click="selectScore(key)"
          class="scoremeter__value"
          :class="{ 'scoremeter__value_bold': selectedScore === item }"
        >
          {{ item.score }}
        </span>
      </div>
    </div>
    <div class="credit-score-step__note">
      {{UIComponentData.Disclaimer.Translations[questionnaireLead.Language]}}
    </div>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import scoreScale from '@/utils/constants/credit-score';
import QuestionCard from '@/components/QuestionCard.vue';

export default {
  name: 'credit-score-step',
  components: {
    QuestionCard,
  },
  props: {
    mobile: Boolean,
    tablet: Boolean,
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  data: () => ({
    scoreScale,
    selectedScore: null,
    buttonDisabled: false,
    angle: 0,
  }),
  computed: {
    ...mapGetters(['questionnaireLead']),
    needleTransform() {
      return {
        transform: `rotate(${this.angle}deg)`,
      };
    },
    scoremeterSize() {
      return {
        width: this.mobile ? 246 : 317,
        height: this.mobile ? 123 : 159,
      };
    },
    canNotSubmit() {
      return this.buttonDisabled || !this.selectedScore;
    },
  },
  methods: {
    ...mapActions(['mutateLead']),
    async submit() {
      this.buttonDisabled = true;
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
      this.buttonDisabled = false;
    },
    selectScore(key) {
      this.selectedScore = scoreScale[key];
      this.questionnaireLead.Credit = this.selectedScore.score;
      this.setTilt(this.selectedScore.angle);
    },
    setTilt(degree) {
      this.angle = degree;
    },
    getDValue(item) {
      return this.mobile ? item.d.mobile : item.d.desktop;
    },
  },
  created() {
    if (this.questionnaireLead.Credit) {
      const scoreKey = this.scoreScale.findIndex(
        ({ score }) => (score === this.questionnaireLead.Credit),
      );
      if (scoreKey !== -1) {
        this.selectScore(scoreKey);
      }
    }
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.credit-score-step {

  .scoremeter {
    width: 317px;
    height: 159px;
    position: relative;
    margin: 0 auto;
    @media (max-width: 435px) {
      width: 220px;
    }
    &__scale-value{
        @media (max-width: 435px) {
          width: 220px;
        }
      }
    &__value {
      cursor: pointer;
      position: absolute;
      color: $primary-blue;
      font-size: 10px;

      &:nth-child(1),
      &:nth-child(10) {
        bottom: 10px;
        @media (max-width: 435px) {
          bottom: 38px;
        }
      }

      &:nth-child(2),
      &:nth-child(9) {
        bottom: 60px;
        @media (max-width: 435px) {
          bottom: 70px;
        }
      }

      &:nth-child(3),
      &:nth-child(8) {
        bottom: 98px;
      }

      &:nth-child(4),
      &:nth-child(7) {
        bottom: 139px;
        @media (max-width: 435px) {
          bottom: 120px;
        }
      }

      &:nth-child(5),
      &:nth-child(6) {
        bottom: 160px;
        @media (max-width: 435px) {
          bottom: 135px;
        }
      }

      &:nth-child(1) {
        left: -33px;
      }

      &:nth-child(2) {
        left: -33px;
      }

      &:nth-child(3) {
        left: -10px;
      }

      &:nth-child(4) {
        left: 44px;
        @media (max-width: 435px) {
          left: 20px;
        }
      }

      &:nth-child(5) {
        left: 110px;
        @media (max-width: 435px) {
          left: 55px;
        }
      }

      &:nth-child(6) {
        right: 110px;
        @media (max-width: 435px) {
          right: 55px;
        }
      }

      &:nth-child(7) {
        right: 44px;
        @media (max-width: 435px) {
          right: 20px;
        }
      }

      &:nth-child(8) {
        right: -12px;
      }

      &:nth-child(9) {
        right: -33px;
      }

      &:nth-child(10) {
        right: -33px;
      }

      &_bold {
        font-weight: bold;
      }

    }

    &__scale {

      &-value {
        cursor: pointer;
      }

    }

    &__needle {
      position: absolute;
      left: calc(50% - #{$scoremeter-needle-width-xlarge} / 2);
      bottom: -8px;
      transform-origin: calc(#{$scoremeter-needle-width-xlarge} / 2) 102px;
      transition: .5s;
      @media (max-width: 435px) {
        left: calc(50% - #{$scoremeter-needle-width-xsmall} / 2);
        transform-origin: calc(#{$scoremeter-needle-width-xsmall} / 2) 60px;
        bottom: 30px;
        height: 60px;
      }
    }
  }

  &__note {
    text-align: center;
    margin-top: 50px;
    font: {
      family: 'Avenir Next';
      weight: normal;
      size: 16px;
    }
    color: $grey;
  }

}
</style>
